import Debug from 'debug';

// Runtime-toggleable client-side console logging — matches guardian-command-center's
// convention. Enable in the browser console: `localStorage.debug = 'eh:*'` (or a
// specific namespace, e.g. 'eh:funnel') then reload; `delete localStorage.debug`
// turns it off. Off by default, so it is safe to ship in production builds and
// works in the container without a rebuild.
//
// This is dev/diagnostic logging only. Production telemetry (canonical events,
// metrics) goes through src/lib/telemetry (App Insights) — not here.
export function createLogger(namespace: string): Debug.Debugger {
  return Debug(`eh:${namespace}`);
}
